import React from 'react';
import './JourneySection.css';

const journeyData = [
  { logo: '/logos/people.webp', number: '100', text: 'Imagineers on board' },
  { logo: '/logos/circle.webp', number: '+300', text: 'Delivered projects' },
  { logo: '/logos/plant.webp', number: '+13', text: 'Years of experience' },
  { logo: '/logos/meter.webp', number: '78', text: 'Customer NPS score' },
  { logo: '/logos/thumb.webp', number: '99%', text: 'Recommendation rate' },
];

const JourneySection = () => {
  return (
    <section className="journey-section">
      <div className="container">
      <h2 className="journey-heading">WE'RE PROUD OF OUR JOURNEY</h2>

      <div className="journey-row">
        {journeyData.slice(0, 3).map((item, index) => (
          <div key={index} className="journey-card">
            <img src={item.logo} alt={`Step ${item.number}`} className="journey-logo" />
            <div className="journey-number">{item.number}</div>
            <p className="journey-text">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="journey-row second-row">
        {journeyData.slice(3).map((item, index) => (
          <div key={index} className="journey-card">
            <img src={item.logo} alt={`Step ${item.number}`} className="journey-logo" />
            <div className="journey-number">{item.number}</div>
            <p className="journey-text">{item.text}</p>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
};

export default JourneySection;
